// extracted by mini-css-extract-plugin
export default {"xIcon":"XIcon_xIcon__3cT6d"};